import { CountryCode } from '../../index.js';
import { VoucherCategory } from '../vouchers/index.js';
export const isEngineV2Case = (kase) => kase.economyEngine === 2;
export const isEngineV2 = (policy) => policy.engine === 2;
// The order v1 produces implicitly: categories missing from its rank map
// share rank 0 and therefore come first.
export const V2_CATEGORY_TIERS = [
    [
        VoucherCategory.DISBURSEMENT,
        VoucherCategory.FEE,
        VoucherCategory.COLLECTIONCOMMISSION,
        VoucherCategory.PAYOUT,
        VoucherCategory.OVERPAYMENT,
        VoucherCategory.VAT,
        VoucherCategory.TRANSACTION,
    ],
    [VoucherCategory.COST],
    [VoucherCategory.COURTCOST],
    [VoucherCategory.INTEREST],
    [VoucherCategory.PRINCIPAL],
];
// The country's statutory limitation, used by both engines.
export const countryPeriods = (countryCode) => countryCode === CountryCode.GL
    ? { debt: { ordinary: 5, foundation: 20 }, interest: 5 }
    : { debt: { ordinary: 3, foundation: 10 }, interest: 3 };
// Zero means "unset" for the debt periods, as in v1's voucher expiration.
const configured = (years, fallback) => (years == null || years === 0 ? fallback : years);
// The years a voucher without an expirationLength of its own takes to expire.
// Engine 1 gives interest the debt period.
export const standardExpirationLength = (countryCode, customExpiration, engine, category) => {
    const country = countryPeriods(countryCode);
    return engine === 2 && category === VoucherCategory.INTEREST
        ? (customExpiration?.interest ?? country.interest)
        : configured(customExpiration?.normal, country.debt.ordinary);
};
export const getEconomyPolicy = (tenant, creditor, engine) => {
    const country = countryPeriods(tenant.countryCode);
    const custom = creditor.settings.customExpiration;
    // A bundle older than the engine must not calculate it as another (§12).
    if (engine !== 1 && engine !== 2) {
        throw new Error(`Unsupported economy engine ${String(engine)}`);
    }
    if (engine === 1) {
        return { engine: 1, trailingYears: custom?.interest ?? country.interest };
    }
    const debt = {
        ordinary: standardExpirationLength(tenant.countryCode, custom, engine, VoucherCategory.PRINCIPAL),
        foundation: configured(custom?.foundation, country.debt.foundation),
    };
    return {
        engine: 2,
        limitation: {
            debt,
            interest: {
                ordinary: standardExpirationLength(tenant.countryCode, custom, engine, VoucherCategory.INTEREST),
                foundation: debt.foundation,
            },
        },
        categoryTiers: V2_CATEGORY_TIERS,
        timezone: tenant.timezone,
        interestRounding: 'exact',
    };
};
//# sourceMappingURL=policy.js.map